import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "src/store";
import { disableTwoFactor } from "src/store/account";

import { Box, Typography } from "@mui/material";
import { LoadingIcon } from "@shared/Loading";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

import { SettingsCard } from "../Components/SettingsCard";
import { useStyles } from "../SettingsPage.style";

type TwoFactorDisableFormProps = {
    onSuccess: () => void;
    onCancel: () => void;
};

export const TwoFactorDisableForm = ({ onSuccess, onCancel }: TwoFactorDisableFormProps) => {
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const { t } = useTranslation(["pages"]);
    const { classes } = useStyles();

    useEffect(() => {
        void (async () => {
            try {
                const { message } = await dispatch(disableTwoFactor()).unwrap();
                showSuccessToast(message);
                onSuccess();
            } catch (err) {
                const error = err as Error;
                showErrorToast(error.message);
                onCancel();
            } finally {
                setLoading(false);
            }
        })();
    }, [dispatch, onCancel, onSuccess]);

    return (
        <SettingsCard title={t("pages:twoFactorDisablePage.metaTitle")}>
            <Box className={classes.loadingBox}>
                {loading ? (
                    <>
                        <LoadingIcon />
                        <Typography variant="body2" color="text.secondary">
                            {t("pages:settingsPage.accountSecurity.twoFactorDisabling")}
                        </Typography>
                    </>
                ) : null}
            </Box>
        </SettingsCard>
    );
};
